/* eslint-disable no-param-reassign */
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { resendmessage } from '@/redux/im/action';
import { MyThunkResult } from '@/typings/reducer';
import { IM_CTX, IM_MESSAGE } from '@/typings/global';
import { outline } from '@/helpers/online';
import { IM_AVATAR, IM_NICK } from '@/helpers/userInfo';

function index({ type, message, ctx }: IM_MESSAGE): JSX.Element {
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { Device } = useSelector(
        ({ IndexReducer }) => ({
            Device: IndexReducer.Device
        }),
        shallowEqual
    );
    // 发送
    const send = async () => {
        dispatch(resendmessage((ctx as IM_CTX).key));
        await IM.IMServer.send(message);
    };
    // 断网点击重新发送不发送
    const _handleResend = async () => {
        if (outline()) return;
        await send();
    };
    const _handleResendMobile = async () => {
        if (!Device.isMobile) return;
        await _handleResend();
    };
    return (
        <li className="im-message-out im-outline-message">
            {IM_AVATAR('offline', '')}
            <div className="im-message-block">
                {IM_NICK('offline', '')}
                <div className="im-outline-content">
                    <i className="icon-send-error" onClick={_handleResendMobile} />
                    <div
                        className="im-message-content"
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                </div>
                <div className="im-resend">
                    当前网络不可用，请检查你的网络，<a onClick={_handleResend}>重新发送{'>>'}</a>
                </div>
            </div>
        </li>
    );
}

export default index;
